<template>
  <div>
    <slot />
  </div>
</template>

<script lang="ts" setup>
import { navbarProps } from './navbar'

defineOptions({
  name: 'VsNavbar',
})

const props = defineProps(navbarProps)

// init here
</script>
